import { all } from '@redux-saga/core/effects'

import { watchGetCouriersAsync } from './courierServices'
import { watchGetTypePositionsAsync } from './typePositionServices'
import { watchGetZonesAsync } from './zoneServices'
import { watchGetWarehousesAsync } from './warehouseServices'
import { watchGetWorkOrderStatesAsync } from './workOrderStateServices'
import { watchGetTypeMovementsAsync } from './typeMovementServices'
import { watchGetSupplierAsync } from './supplierServices'
import { watchGetTypesAsnDocumentAsync } from './typeAsnDocumentServices'
import { watchGetTypesAsnIncomeAsync } from './typeAsnIncomeServices'
import { watchGetAsnStatesAsync } from './asnStateServices'
import { watchGetTypesAsnSourceASync } from './typeAsnSourceServices'
import { watchGetTypesConfigurationAsync } from './typeConfigurationServices'
import { watchGetTypesInventoryIncidentAsync } from './typeInventoryIncidentServices'
import { watchGetConfigurationAsync } from './configurationServices'
import { watchGetUserDataAsync } from './userDataServices'
import { watchGetSupplierOriginAsync } from './supplierOriginServices'
import { watchGetSubZonesAsync } from './subZoneServices'
import { watchGetProductOriginsAsync } from './productOriginsServices'
import { watchGetOrderOriginsAsync } from './orderOriginServices'
import { watchGetTypesOrderAsync } from './typeOrderServices'
import { watchGetTypesPickingRouteAsync } from './typePickingRouteServices'
import { watchGetTypeStorageAsync } from './typeStorageServices'
import { watchGetTypesPriorityAsync } from './typePriorityServices'
import { watchGetFlowsAsync } from './flowServices'
import { watchGetTypesAlertAsync } from './typeAlertServices'
import { watchGetTypeProcessAsync } from './typeProcessServices'
import { watchGetTypeOperationAsync } from './typeOperationServices'
import { watchGetTypeVasAsync } from './typeVasServices'
import { watchGetTypeValidationVasAsync } from './typeValidationVasServices'
import { watchGetFlowVasAsync } from './flowVasServices'
import { watchGetTypesSettingAsync } from './typeSettingServices'
import { watchGetSettingsAsync } from './settingsServices'

export default function* rootSaga() {
  yield all([
    watchGetTypesPriorityAsync(), // Tipos de prioridad
    watchGetCouriersAsync(), // Courier
    watchGetTypePositionsAsync(), // TypePositions
    watchGetZonesAsync(), // Zones
    watchGetWarehousesAsync(), // Warehouse
    watchGetWorkOrderStatesAsync(), // WorkOrderStates
    watchGetTypeMovementsAsync(), // TypeMovements
    watchGetSupplierAsync(), // Supplier
    watchGetSupplierOriginAsync(), // SupplierOrigin
    watchGetTypesAsnDocumentAsync(), // Tipo ASN Doc
    watchGetTypesAsnIncomeAsync(), // Tipo ASN Ingreso
    watchGetAsnStatesAsync(), // Tipo Estado ASN
    watchGetTypesAsnSourceASync(), // Tipo Origen ASN
    watchGetTypesConfigurationAsync(), // Tipo Configuracion
    watchGetTypesInventoryIncidentAsync(), // Tipo Inventory Incident
    watchGetConfigurationAsync(), // Cnnfiguracion
    watchGetUserDataAsync(), // UserData
    watchGetSubZonesAsync(), // Subzones
    watchGetProductOriginsAsync(),
    watchGetOrderOriginsAsync(),
    watchGetTypesOrderAsync(),
    watchGetTypesPickingRouteAsync(),
    watchGetTypeStorageAsync(),
    watchGetTypesAlertAsync(),
    watchGetFlowsAsync(),
    watchGetTypeProcessAsync(),
    watchGetTypeOperationAsync(),
    watchGetTypeVasAsync(),
    watchGetTypeValidationVasAsync(),
    watchGetFlowVasAsync(),
    watchGetTypesSettingAsync(), // Tipos de Setting
    watchGetSettingsAsync() // Settings por tipo
  ])
}

